// extracted by mini-css-extract-plugin
export default {"label":"InputText_label__mjfMU","valueOnly":"InputText_valueOnly__tj6ek"};